import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { useKeycloakStore, useUserMeStore } from '../../../../../store';
import { RealmRole } from '@web/common';
import { LanguagePicker } from '@web/common-ui';

export const LanguagePickerContainer = observer(() => {
  const userMeStore = useUserMeStore();
  const kcStore = useKeycloakStore();
  const { t, i18n } = useTranslation('dialogs');
  const realmRoles = useMemo(() => {
    return kcStore.realmRoleList || [];
  }, [kcStore]);

  const isUserLoggedIn = kcStore.authenticated;

  const changeLanguage = (lang: 'de' | 'en') => {
    if (isUserLoggedIn && realmRoles.includes(RealmRole.Participant)) {
      userMeStore.setMyInfo({ language: lang });
    }
  };

  return (
    <LanguagePicker
      currentLang={userMeStore.myInfo?.language}
      onSave={(lang) => changeLanguage(lang)}
      t={t}
      i18n={i18n}
    />
  );
});
